import { ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild } from '@angular/core';
import {AttachmentUploadViewModel} from '../view-models/attachment-upload-view.model';
import {AttachmentValidationService} from '../services/attachment-validation.service';
import {DomEvent} from '@shared/interfaces/dom-event';

@Component({
    selector: 'app-message-attachment-menu',
    templateUrl: './message-attachment-menu.component.html',
    styleUrls: ['./message-attachment-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageAttachmentMenuComponent {
    public readonly attachmentsList = input<AttachmentUploadViewModel[]>([]);
    public readonly addFiles = output<File[]>();
    public readonly removeAttachment = output<AttachmentUploadViewModel>();

    public readonly attachmentFile = viewChild.required<ElementRef>('attachmentFile');
    public readonly fileTypeWhiteList = AttachmentValidationService.fileTypeWhiteList;

  public triggerFileInput(): void {
    this.attachmentFile().nativeElement.click();
  }

  public filesChanged(event: Event): void {
    const domEvent = event as DomEvent<HTMLInputElement>;
    const fileList = domEvent.target.files;
    const files = Array.from(fileList);

    this.addFiles.emit(files);
    this.attachmentFile().nativeElement.value = '';
  }

  public removeClicked(attachment: AttachmentUploadViewModel, event: Event): void {
    event.stopPropagation();  // To prevent the attachment popup from closing

    this.removeAttachment.emit(attachment);
  }
}
